import { LIST_VIEW_NAME, PORTAL_VIEW_NAME } from "../core/constants";
import { getDomainCfg } from "../core/state";
import { getCurrentViewName } from "../core/views";

export function redirectToEditorProject(projectCode : string) {
  redirectTo(getRedirectUrl(getDomainCfg().viewSettings.editorView, projectCode));
}

export function redirectToQuestView(questId : string) {  
  redirectTo(getRedirectUrl(getDomainCfg().viewSettings.questView, questId, "quest"));
}

export function redirectToPortalRequested() {
  if (getCurrentViewName() === PORTAL_VIEW_NAME) return;
  redirectTo(getRedirectUrl(getDomainCfg().viewSettings.portalView));
}

export function redirectToProjectListRequested() {
  if (getCurrentViewName() === LIST_VIEW_NAME) return;
  redirectTo(getRedirectUrl(getDomainCfg().viewSettings.projectsView));
}

export const getRedirectUrl = (view : string, code? : string, codeParam? : string) : string => {
  let redirectUrl = view;

  if (view.indexOf('http') < 0) {
    const site = window.location.origin;
    redirectUrl = site + (view.startsWith('/') ? '' : '/') + view;
  }

  const paramOperator = redirectUrl.indexOf('?') < 0 ? '?' : '&';
  if (code !== undefined) {
    const codeParamName = codeParam || 'sp';
    return redirectUrl + paramOperator + codeParamName+ '=' + code.toUpperCase();
  }
  console.log('redirect url:', redirectUrl);
  return redirectUrl;
}

export const redirectTo = (url : string, delay : number = 300) : void => {
  setTimeout(() => {    
    window.location.href = url;
  }, delay);
}

export const redirectToNewTab = (url : string) : void => {
  window.open(url);
}
